import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import { presetApi } from '../api';
import { presetKeys } from './preset.keys';

type DeletePresetResponse = { id: string; deleted: boolean };

export function useDeletePreset(
  options?: UseMutationOptions<DeletePresetResponse, Error, string>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['presets', 'delete'],
    mutationFn: presetApi.remove,
    ...mutationOptions,
    onSuccess: (response, id, onMutateResult, context) => {
      toast({ title: 'Preset excluído com sucesso', variant: 'success' });
      queryClient.invalidateQueries({ queryKey: presetKeys.all });
      providedOnSuccess?.(response, id, onMutateResult, context);
    },
    onError: (error, variables, onMutateResult, context) => {
      toast({
        title: 'Erro ao excluir preset',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, onMutateResult, context);
    },
  });
  const deletePreset = (id: string) => mutation.mutateAsync(id);
  return {
    deletePreset,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
